var _g, _path, _ellipse, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedinInvitationFailed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.27
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "black"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4176 27.1391H11.5775V15.6191H15.4176V27.1391ZM24.8514 15.3116C27.4112 15.3118 29.2665 16.9637 29.2665 20.5091V27.1391H25.4264V20.9566C25.4264 19.4078 24.8765 18.3966 23.4814 18.3966C23.0497 18.3998 22.6288 18.5347 22.2764 18.7841C21.924 19.0335 21.6567 19.3855 21.5101 19.7916C21.41 20.0924 21.3671 20.4099 21.3826 20.7266V27.1266H17.5426C17.5426 27.1266 17.5426 16.6586 17.5426 15.6066H21.3826V17.2316C21.7315 16.6265 22.239 16.1273 22.8501 15.7891C23.4612 15.451 24.1535 15.2858 24.8514 15.3116ZM13.4975 10.0128C13.7785 9.98102 14.063 10.0084 14.3325 10.0941C14.6022 10.1799 14.8514 10.3218 15.0625 10.5103C15.2735 10.6987 15.4419 10.9298 15.5576 11.1878C15.6732 11.4461 15.7338 11.7262 15.7338 12.0091C15.7338 12.2921 15.6732 12.572 15.5576 12.8303C15.442 13.0885 15.2734 13.3194 15.0625 13.5078C14.8514 13.6964 14.6022 13.8383 14.3325 13.9241C14.063 14.0098 13.7785 14.0384 13.4975 14.0066C12.968 14.0066 12.4595 13.796 12.085 13.4216C11.7105 13.0471 11.5 12.5387 11.5 12.0091C11.5001 11.4798 11.7108 10.9722 12.085 10.5978C12.4595 10.2234 12.9679 10.0128 13.4975 10.0128Z",
    fill: "white"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 32.6801,
    cy: 7.68,
    rx: 7.6801,
    ry: 7.68,
    fill: "#E9004A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33 10.5C33.5523 10.5 34 10.9477 34 11.5C34 12.0523 33.5523 12.5 33 12.5C32.4477 12.5 32 12.0523 32 11.5C32 10.9477 32.4477 10.5 33 10.5ZM33 2.5C33.5523 2.5 34 2.94772 34 3.5V8.5C34 9.05228 33.5523 9.5 33 9.5C32.4477 9.5 32 9.05228 32 8.5V3.5C32 2.94772 32.4477 2.5 33 2.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinInvitationFailed);
export default __webpack_public_path__ + "static/media/linkedin-invitation-failed.ae6655479a976a2a736838625c176b74.svg";
export { ForwardRef as ReactComponent };